import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PaymentIcon from "@mui/icons-material/Payment";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import preferences from "../../assets/preferences.svg";

const Settings = ({ account }) => {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!account) return null;

  return (
    <>
      <style>{`
        .settings-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 60px;
          padding: 40px 20px;
          min-height: 80vh;
        }

        .settings-left {
          width: 55%;
        }

        .settings-right {
          width: 40%;
          text-align: center;
        }

        .settings-image {
          max-width: 320px;
          margin: auto;
        }

        .settings-privacy {
          margin-top: 20px;
          color: #64748b;
          font-size: 15px;
        }

        .setting-option {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 18px 20px;
          border-radius: 14px;
          text-decoration: none;
          background: white;
          transition: 0.2s ease;
          cursor: pointer;
        }

        .setting-option:hover {
          background: #f8fafc;
        }

        .setting-left-row {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .setting-icon {
          width: 44px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #eef4ff;
          border-radius: 12px;
          color: #2563eb;
        }

        .setting-option h5 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
        }

        .setting-option p {
          margin: 0;
          font-size: 14px;
          color: #64748b;
        }

        .setting-arrow {
          color: #94a3b8;
        }

        @media(max-width: 992px){
          .settings-wrapper {
            flex-direction: column;
            gap: 40px;
          }

          .settings-left,
          .settings-right {
            width: 100%;
          }

          .settings-right {
            order: -1;
          }
        }
      `}</style>

      <div className="settings-wrapper container pt-2 mt-2">

        {/* LEFT */}
        <div className="settings-left">

          <Link to={"/u/" + account.username} className="setting-option">
            <div className="setting-left-row">
              <div className="setting-icon">
                <AccountCircleIcon />
              </div>
              <div>
                <h5>Edit Profile</h5>
                <p>Make changes to your username, full name, email, phone, profile picture and more...</p>
              </div>
            </div>
            <ChevronRightIcon className="setting-arrow" />
          </Link>

          <Link to="/payments" className="setting-option">
            <div className="setting-left-row">
              <div className="setting-icon">
                <PaymentIcon />
              </div>
              <div>
                <h5>Payments</h5>
                <p>Keep a track of your registrations and payments</p>
              </div>
            </div>
            <ChevronRightIcon className="setting-arrow" />
          </Link>

          <Link to="/notification-settings" className="setting-option">
            <div className="setting-left-row">
              <div className="setting-icon">
                <NotificationsIcon />
              </div>
              <div>
                <h5>Notification Settings</h5>
                <p>Choose when and how to get notified</p>
              </div>
            </div>
            <ChevronRightIcon className="setting-arrow" />
          </Link>

          <Link to="/change-password" className="setting-option">
            <div className="setting-left-row">
              <div className="setting-icon">
                <ChangeCircleIcon />
              </div>
              <div>
                <h5>Change Password</h5>
              </div>
            </div>
            <ChevronRightIcon className="setting-arrow" />
          </Link>

          <div className="setting-option">
            <div className="setting-left-row">
              <div className="setting-icon">
                <LogoutIcon />
              </div>
              <div>
                <h5>Logout</h5>
              </div>
            </div>
            <ChevronRightIcon className="setting-arrow" />
          </div>

        </div>

        {/* RIGHT */}
        <div className="settings-right d-flex flex-wrap align-items-center">
          <img src={preferences} alt="settings" className="settings-image w-100 mt-3 mt-lg-5"  />
          <p className="settings-privacy w-100">
            If you'd like to learn more about privacy, you can read about it in the{" "}
            <Link to="/privacy-policy">Privacy Policy</Link>
          </p>
        </div>

      </div>
    </>
  );
};

export default Settings;